import { createFileRoute } from '@tanstack/react-router'
import { ChannelPage } from '../../components/channel-page'

// Direct message by channel id (DMs have no slug) — DIS-57.
export const Route = createFileRoute('/_app/dm/$id')({
  validateSearch: (s: Record<string, unknown>): { thread?: string } => (typeof s.thread === 'string' ? { thread: s.thread } : {}),
  component: () => {
    const { id } = Route.useParams()
    const { me } = Route.useRouteContext()
    return <ChannelPage slug={id} me={me} />
  },
})
